export default ["dev","error-page.html","index-2.html","index.html","privacy.html","theme-2-aside.html","theme-2.html"]


// WEBPACK FOOTER //
// app/scripts/files.js